import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';
import { GlobalMethodsService } from '../../../../services/global-methods.service';
import { WebrtcDeviceViewComponent, PTZCommand } from 'libs/vaelsys-webrtc-lib';
import { Platform } from '@ionic/angular';
declare let JoystickController: any;
@Component({
  selector: 'app-ptz',
  templateUrl: './ptz.component.html',
  styleUrls: ['./ptz.component.scss'],
})
export class PtzComponent implements OnInit, AfterViewInit {

  @Input('webRtcView') webRtcView: WebrtcDeviceViewComponent;
  @Input('portrait') portrait: boolean;
  @ViewChild('ptz') ptz: ElementRef;
  @ViewChild('center') center: ElementRef;
  @ViewChild('joywrapper') joywrapper: ElementRef;

  @ViewChild('up') up: ElementRef;
  @ViewChild('down') down: ElementRef;
  @ViewChild('right') right: ElementRef;
  @ViewChild('left') left: ElementRef;

  joystick: any;
  movePTZ: boolean;
  constructor(private renderer: Renderer2,
    private gms: GlobalMethodsService,
    public platform: Platform) { }

  async ngAfterViewInit(): Promise<void> {
    this.joystick = new JoystickController("center", 64, 8);
    await this.loop();
    this.gms.stopPtz$.subscribe(async () => {
      await this.stopMove();
    });
  }

  ngOnInit() {
  }

  async moveUp(){
    let result = await this.startPTZ(PTZCommand.up);
    if(result){
      this.renderer.addClass(this.up.nativeElement, "ptz-active");
      this.renderer.addClass(this.joywrapper.nativeElement, "center-top");
    }
  }
  async moveRight(){
    let result = await this.startPTZ(PTZCommand.right);
    if(result){
      this.renderer.addClass(this.right.nativeElement, "ptz-active");
      this.renderer.addClass(this.joywrapper.nativeElement, "center-right");
    }
  }
  async moveDown(){
    let result = await this.startPTZ(PTZCommand.down);
    if(result){
      this.renderer.addClass(this.down.nativeElement, "ptz-active");
      this.renderer.addClass(this.joywrapper.nativeElement, "center-bottom");
    }
  }
  async moveLeft(){
    let result = await this.startPTZ(PTZCommand.left);
    if(result){
      this.renderer.addClass(this.left.nativeElement, "ptz-active");
      this.renderer.addClass(this.joywrapper.nativeElement, "center-left");
    }    
  }
  

  async stopMove(){
    let result = await this.stopPTZ();
    if(result){
      this.renderer.removeClass(this.up.nativeElement, "ptz-active");
        this.renderer.removeClass(this.down.nativeElement, "ptz-active");
        this.renderer.removeClass(this.right.nativeElement, "ptz-active");
        this.renderer.removeClass(this.left.nativeElement, "ptz-active");
        this.renderer.removeClass(this.joywrapper.nativeElement, "center-top");
        this.renderer.removeClass(this.joywrapper.nativeElement, "center-right");
        this.renderer.removeClass(this.joywrapper.nativeElement, "center-bottom");
        this.renderer.removeClass(this.joywrapper.nativeElement, "center-left");
    }
  }

  async update() {
    if(this.joystick.value.x !== 0 && this.joystick.value.y !== 0){
      //top
      if((this.joystick.yPosition <= -57.045 && this.joystick.yPosition >= -64)){
        this.renderer.addClass(this.up.nativeElement, "ptz-active");

        //TODO: PTZ TOP
        if(!this.movePTZ){
          this.movePTZ = true;
          await this.startPTZ(PTZCommand.up);
        }
      //right
      }else if((this.joystick.xPosition >= 57.045 && this.joystick.yPosition <= 64)){
        this.renderer.addClass(this.right.nativeElement, "ptz-active");
        //TODO: PTZ RIGHT
        if(!this.movePTZ){
          this.movePTZ = true;
          await this.startPTZ(PTZCommand.right);
        }
      //bottom
      }else if((this.joystick.yPosition >= 57.045 && this.joystick.yPosition <= 64)){
        this.renderer.addClass(this.down.nativeElement, "ptz-active");
        //TODO: PTZ BOTTOM
        if(!this.movePTZ){
          this.movePTZ = true;
          await this.startPTZ(PTZCommand.down);
        }
      //left
      }else if((this.joystick.xPosition <= -57.045 && this.joystick.yPosition >= -64)){
        this.renderer.addClass(this.left.nativeElement, "ptz-active");
        //TODO: PTZ LEFT
        if(!this.movePTZ){
          this.movePTZ = true;
          await this.startPTZ(PTZCommand.left);
        }
      }else{
        //TODO: stop PTZ
        if(this.movePTZ){
          this.movePTZ = false;
          this.renderer.removeClass(this.up.nativeElement, "ptz-active");
          this.renderer.removeClass(this.down.nativeElement, "ptz-active");
          this.renderer.removeClass(this.right.nativeElement, "ptz-active");
          this.renderer.removeClass(this.left.nativeElement, "ptz-active");
          await this.stopPTZ();
        }
      }
    }else{
      //TODO: stop PTZ
      if(this.movePTZ){
        this.movePTZ = false;
        this.renderer.removeClass(this.up.nativeElement, "ptz-active");
        this.renderer.removeClass(this.down.nativeElement, "ptz-active");
        this.renderer.removeClass(this.right.nativeElement, "ptz-active");
        this.renderer.removeClass(this.left.nativeElement, "ptz-active");
        await this.stopPTZ();
      }
    }
  }

  async startPTZ(command: PTZCommand): Promise<boolean>{
    return new Promise(async (resolve, reject) => {
      this.webRtcView.ptzControl(command, 100)
      .then(
        (value) => {
          resolve(value);
        }
      ).catch(
        (error) => {
          resolve(false);
        }
      )
    });
  }

  async stopPTZ(): Promise<boolean>{
    return new Promise(async (resolve, reject) => {
      this.webRtcView.ptzControl(PTZCommand.stop, 0)
      .then((value) => {
        resolve(value);
      })
      .catch(
        (error) => {
          resolve(false);
        }
      );
    });
  }

  async loop() {
    window.requestAnimationFrame(() => this.loop());
    await this.update();
  }
}
